import React from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import { Image } from '../Image/Image'

export interface HighlightImageProps extends IGatsbyImageData {
  gatsbyImageData: IGatsbyImageData
}

export const HighlightImage = ({ gatsbyImageData }: HighlightImageProps) => (
  <div className="frw-image-wrapper">
    <Image isDecorative gatsbyImageData={gatsbyImageData} />
  </div>
)
export default HighlightImage
